import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ThemeSharedModule } from '@abp/ng.theme.shared';
import { SharedModule } from 'src/app/shared/shared.module';
import { NotificationStateService } from 'src/app/services/notification-state.service';

@Component({
  selector: 'app-custom-toolbar',
  standalone: true,
  imports: [
    CommonModule,
    ThemeSharedModule,
    SharedModule
  ],
  templateUrl: './custom-toolbar.component.html',
  styleUrls: ['./custom-toolbar.component.scss']
})
export class CustomToolbarComponent {
  constructor(private notificationStateService: NotificationStateService) {}

  public triggerOpenPanel(): void {
    this.notificationStateService.openPanel$.next();
  }
}
